<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
<!--    <keep-alive>-->
      <router-view v-if="isRouterAlive"></router-view>
<!--    </keep-alive>-->
  </div>
</template>

<script>
export default {
  name: 'app',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  created() {
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}

</script>

<style>
body {
  background-color: #efeff4;
  height: 100%;
}

#app {
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue